<template>
  <div class="mobile-navigation-toggle" @click.prevent="showMainNavigation">
    <span></span>
  </div>
</template>

<script>
export default {
  methods: {
    showMainNavigation () {
      this.$store.commit('mainNavigation', !this.$store.state.showMainNavigation)
    }
  }
}
</script>

<style lang="scss">
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';

@import '~@animations/durations/variables';
@import '~@animations/easings/variables';

$header-link-color: #567697;
$header-link-color_hover: #0B2B62;
$header-link-color_selected: #aabacb;

.mobile-navigation-toggle {
  position: absolute;
  top: calc(50% + 3px);
  right: 20px;

  width: 24px;
  height: 20px;

  transform: translateY(-50%);

  cursor: pointer;

  &:before {
    content: "Menu";
    position: absolute;
    left: 0;
    top: 50%;

    transform: translate(calc(-100% - 10px), -50%);

    font-size: 13px;
    font-weight: 700;

    color: $color-red;

    @at-root .main-navigtaion-shown #{&} {
      content: "Luk";
    }

    @at-root .internet-explorer #{&} {
      transform: translate(-100%, -50%);
      left: -10px;
    }
  }

  @media #{$above-breakpoint-768} {
    display: none;
  }

  span {
    display: block;

    height: 2px;
    width: 24px;

    background-color: $color-red;

    transform: translateY(3px);

    transition: all $duration-normal $easeing-OutExpo;

    @at-root .main-navigtaion-shown #{&} {
      transform: translateY(8px) rotate(-45deg);
    }
  }

  span:before, span:after {
    content: "";

    display: block;

    height: 2px;
    width: 24px;

    background-color: $color-red;

    transition: all $duration-normal $easeing-OutExpo;
  }

  span:before {
    transform: translateY(6px);

    @at-root .main-navigtaion-shown #{&} {
      opacity: 0;
      transform: translateX(7px) translateY(6px) rotate(45deg);
    }
  }

  span:after {
    transform: translateY(10px);

    @at-root .main-navigtaion-shown #{&} {
      transform: translateY(-2px) rotate(90deg);
    }
  }

  &:hover {
    @media #{$above-breakpoint-768} {
      span, span:before, span:after {
        background-color: $color-gold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/elements/hamburger.vue